jQuery(document).ready(function ($) {

    const $site_navbar = $('.site-navbar');
    const $site_header = $('.site-header');
    const $site_footer = $('.site-footer');


    ;(function () {

        const $search_box = $('.masthead-video .search-box');
        const $masthead_practice_caption = $('.masthead-practice .masthead__caption');
        const set_opacity = function (offset) {
            this.css({
                'opacity': Math.max(0.9 - (offset / this.offset().top), 0)
            })
        };
        $(window).on('scroll', function (event) {
            const offset = $site_navbar.offset().top;
            if ($search_box.length) {
                const recent_toughts = $search_box.find('.recent-toughts');
                const display = recent_toughts.css('display') === 'block';
                display ? $search_box.css({'opacity': '.9'}) : set_opacity.call($search_box, offset)
            }
            //$masthead_practice_caption.length && set_opacity.call($masthead_practice_caption, offset);
        });
    })();

    ;(function () {

        const $form = $('.masthead-members__form');

        const handle_active = function (e) {
            e.preventDefault();
            const $this = $(this);
            const $letter_input = $form.find('[name="letter"]');
            const letter = $this.data('letter');
            const $parent = $this.parent();
            const $list = $parent.parent();

            $list.find('.-pre-active').removeClass('-pre-active');
            $letter_input.val('');
            letter && $letter_input.val(letter);
            $parent.addClass('-pre-active');
        };

        $('.members-abc__list a').on('click', handle_active);

    })();

    ;(function () {

        const handle_active = function (e) {
            e.preventDefault();
            $(this).parent().toggleClass('-pre-info-active')
        };

        $('.member-result__info-icon').on('click', handle_active);
    })();

    ;(function () {

        const $contact_list = $('.contact__list');
        $('body').on('click', '.contact__location-close', function (e) {
            e.preventDefault();
            const $this = $(this);
            $this.closest('.contact__location').fadeOut(function () {
                $contact_list.find('li').removeClass('-pre-active');
                $(this).remove();
            });
        });

        $('.contact__toggle').on('click', function (e) {
            e.preventDefault();
            const $current_toggle = $(this);
            const item = $current_toggle.data('item');
            const $location = $(`#${$current_toggle.data('location_id')}`);
            const $parent = $current_toggle.parent();
            const $list = $parent.parent();
            const page_id = $list.data('page_id');
            const title = $current_toggle.find('> span').text();

            $current_toggle.find('> span').html('<i class="fas fa-spinner fa-spin"></i>');
            $list.find('li.-pre-active').removeClass('-pre-active');
            $list.find('.contact__location').remove();

            const position = $parent.index(); // The parent index, must be call after remove .portfolio-box parent
            const $lastItem = $list.find('> li:last-child'); // Last col parent, must be call after remove .portfolio-box parent

            let inRow = 1; // xs
            if (window.innerWidth >= 768) inRow = 2;

            const itemPosition = inRow - (position % inRow) - 1;

            // Get the active parent col
            const getActiveItem = () => {
                let _item;
                if (itemPosition === 0)
                    return $parent;
                _item = $parent.nextAll().slice(0, itemPosition).last();
                if (_item.length === 0 || $lastItem.index() === position)
                    _item = $lastItem;
                return _item
            };

            const success = (output) => {
                $(`<li class="contact__location" style="display: none">${output}</li>`).insertAfter(getActiveItem()).promise().done(_ => $('.contact__location').fadeIn(function () {
                    const $current = $(this);
                    $current.find('.contact__location-body').focus();
                }));
            };

            const output = $location.html();

            success(output);
            $parent.addClass('-pre-active');
            $current_toggle.find('> span').html(title)

            /*const data = {
                item,
                page_id,
                'action': 'handle_contact_location_body'
            };

            jQuery.ajax({
                data,
                success,
                type: 'GET',
                url: pearlcohen_get_ajax_url(),
                dataType: 'html',
            }).
            done( _ => {
                $parent.addClass('-pre-active');
                $current_toggle.find('> span').html(title)
            } );*/
        })
    })();

    ;(async function () {

        if (window.innerWidth <= 991) return;

        $('.member-result__info-button').tooltip({
            'container': 'body'
        });

        {
            const $tooltip = $('.masthead__contact-list [data-toggle="tooltip"]');

            $tooltip.tooltip();

            // The tooltip is about to be shown.
            $tooltip.on('show.bs.tooltip', function (e) {
                const $this_link = $(this);
                const $parent = $this_link.parent();
                const $current_list = $parent.parent();
                const is_rtl = pearlcohen_is_rtl();
                setTimeout(_ => {
                    $parent.find('.tooltip').css({
                        'left': is_rtl ? 'auto' : '0',
                        'right': is_rtl ? '0' : 'auto',
                        'width': `${$current_list.width()}px`
                    });
                }, 0);
            });
        }

        $('.-pre-copy-to-clipboard').on('click', function (e) {
            const $this_link = $(this);
            const describedby = $this_link.attr('aria-describedby');
            const $parent = $this_link.parent();
            const $current_list = $parent.parent();
            const $tooltip = $(`#${describedby}`);
            if (window.innerWidth >= 1200) {
                try {
                    e.preventDefault();
                    const original_title = $this_link.attr('data-original-title');
                    const result = original_title.match(/<span>(.*?)<\/span>/g).map(val => val.replace(/<\/?span>/g, ''));
                    let $temp = $(`<input>`);
                    $this_link.append($temp);
                    $temp.val(result).select();
                    document.execCommand('copy');
                    $temp.remove();
                    $tooltip.find('.tooltip-inner').text($current_list.data('copy_text'));
                } catch (e) {
                    console.error(e)
                }
            }

        })
    })();

    ;(async function () {
        const $search_box = $('.masthead-video .search-box');
        const $search_input = $search_box.find('[type="search"]');
        const $recent_toughts = $search_box.find('.recent-toughts');
        const $recent_toughts_subtitle = $recent_toughts.find('.recent-toughts__subtitle');
        const $recent_toughts_list = $recent_toughts.find('.recent-toughts__list');

        $search_input.on('keyup', function (e) {
            const $this = $(this);
            clearTimeout($.data(this, 'timer'));
            $this.data('timer', setTimeout(pearlcohen_handle_search_service.bind($this, $recent_toughts_list, $recent_toughts_subtitle), 500));
        });

        $search_input.on('focusin', () => {
            $search_box.css({'opacity': '1'});
            $recent_toughts.show();
        });

        $search_input.on('blur', function (e) {
            const $this = $(this);
            const current_val = $this.val().trim();
            $search_box.css({'opacity': '.9'});
            !current_val.length && $recent_toughts.hide();
        });

        $search_box.find('[type="button"]').on('click', function () {
            $search_input.val('');
            $search_input.trigger('blur');
        });

    })();


    $('.find-attorney__counter-number').each(function () {
        var size = $(this).text().split(".")[1] ? $(this).text().split(".")[1].length : 0;
        $(this).prop('Counter', 0).animate({
            Counter: $(this).text()
        }, {
            duration: 5000,
            step: function (func) {
                $(this).text(parseFloat(func).toFixed(size));
            }
        });
    });

    ;(_ => $site_footer.find('.site-footer__cover').addClass('-pre-animate-cover-scale'))();

    ;(function () {
        $('.page-mirror').hover(function () {
            const $current_item = $(this);
            const $current_section = $current_item.closest('.pages-mirror');
            $current_section.find('.pages-mirror__cover').removeClass('-pre-cover-active');
            $current_section.find(`.pages-mirror__cover[data-cover="${$current_item.attr('id')}"]`).addClass('-pre-cover-active');
        });
    })();

    ;(function () {
        const $current_section = $('.innovation-center');
        $current_section.find('.section-heading__reload').on('click', function (e) {
            e.preventDefault();

            const $col = $current_section.find('.innovation-center__col');
            let delay = 0;
            $col.each(async function () {
                const $current_col = $(this);
                setTimeout(_ => {
                    const $first_thumbnail = $current_col.find('> .innovation-thumbnail:nth-child(1)');

                    $current_col.addClass('-pre-animat__innovation-thumbnail');
                    setTimeout(_ => {

                        const first_thumbnail_HTML = $first_thumbnail.detach();
                        $current_col.append(first_thumbnail_HTML);
                        $current_col.removeClass('-pre-animat__innovation-thumbnail');
                    }, 500);

                }, delay);
                delay += 150;
            });
        })
    })();

    ;(function () {
        const $indexs_slider = $('.indexs-slider');
        const $slideshow = $indexs_slider.find('.indexs-slider__list');

        const slickOptions = {
            rtl: pearlcohen_is_rtl(),
            accessibility: false,
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            draggable: true,
            arrows: true,
            dots: false,
            adaptiveHeight: false,
        };

        const slider = $slideshow.slick(slickOptions);
        $slideshow.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
            const thisSlide = slick.$slides[nextSlide];
            const $slide = $(thisSlide);
            const name = $slide.data('footer_name');
            const $footer_name = $indexs_slider.find('.indexs-slider__footer-name');
            $footer_name.fadeOut('fast', function () {
                $(this).text(name).fadeIn('fast');
            });
        });
    })();

    ;(function () {
        const $slideshow = $('.testimonials__slider');

        let slidesToShow = 3
        if ($(window).innerWidth() < 991) {
            slidesToShow = 2
        }
        if ($(window).innerWidth() < 767) {
            slidesToShow = 1
        }
        const slickOptions = {
            rtl: pearlcohen_is_rtl(),
            accessibility: false,
            infinite: true,
            slidesToShow: slidesToShow,
            slidesToScroll: 1,
            draggable: true,
            arrows: true,
            dots: false,
            adaptiveHeight: false,
        };

        const slider = $slideshow.slick(slickOptions);
        $slideshow.on('beforeChange', function (event, slick, currentSlide, nextSlide) {

        });
    })();

    ;(function () {
        $('.apply-banner__btn').on('click', function () {
            const $el = $($(this).attr('data-target'))
            const text = $(this).text()
            $el.find('.gform_fields > li input[type="hidden"]').val(text)
        })
    })()


    ;(function () {
        const is_mobile_view = () => window.innerWidth <= 767;
        const $innovation_center = $('.innovation-center');
        const get_cols = () => $innovation_center.find('.innovation-center__col');
        const set_cols_height = (height) => get_cols().css({'height': height});

        const init_col_height = function () {
            let height = 0;
            const cols = get_cols();
            cols.each(function () {
                const $current_col = $(this);
                const thumbnail_height = $current_col.find('> .innovation-thumbnail').outerHeight();
                if (thumbnail_height > height)
                    height = thumbnail_height
            });
            set_cols_height(`${height}px`);
        };
        is_mobile_view() && init_col_height();
        $(window).on('resize', () => is_mobile_view() ? init_col_height() : set_cols_height(''));


        /**
         * Practices
         * added 11.4.22
         */
        $('.practices').on('click', ' .trigger-sublist', function (e) {
            e.preventDefault()
            $(this).toggleClass('active').siblings('.practices__sublist').slideToggle()
        })

        $('.practices__filters a[data-location]').on('click', function (e) {
            e.preventDefault()
            const $this = $(this)
            const $showAllWrapper = $('.practices__show-all')
            if($this.hasClass('practices__show-all-btn'))
                $showAllWrapper.fadeOut()
            else
                $showAllWrapper.fadeIn()


            $('.practices__show-all-btn').fadeIn()
            if ($this.hasClass('active')) return
            $('.practices__filters .active').removeClass('active')
            $(this).addClass('active')
            const timing = 450

            const location = $this.data('location')
            if (!location) {
                // Display all

                animatePractices(timing)
                setTimeout(function () {
                    display_practices($('.practices__list [data-locations]'))
                }, timing)
                return;
            }
            animatePractices(timing)
            setTimeout(function () {
                let toDisplay = $('.practices__list [data-locations]').filter(function (index, el) {
                    const elLocations = $(this).data('locations').toString()
                    return elLocations.split(',').includes(location.toString())
                })
                let toHide = $('.practices__list [data-locations]').filter(function (index, el) {
                    const elLocations = $(this).data('locations').toString()
                    return !elLocations.split(',').includes(location.toString())
                })

                display_practices(toDisplay, toHide, location)
            }, timing)
        })

        function display_practices(toDisplay = null, toHide = null, location = '') {

            if(toDisplay) {
                toDisplay.show().removeClass('hidden', )

                toDisplay.each(function () {
                    const $link = $(this).find('a')
                    $link.attr('href', $link.attr('href').split('?')[0] + '?location=' + location)
                })
            }

            toHide && toHide.hide().addClass('hidden')

            /***
             * Handle empty groups
             */
            $('.practices__sublist').each(function () {
                if($(this).find('li:not(.hidden)').length) {
                    $(this).closest('li').show()
                } else {
                    $(this).siblings('.active').removeClass('active')
                    $(this).hide().closest('li').hide()
                }
            })
        }
        function animatePractices(timing) {
            const $wrapper = $('.practices__list-wrapper')
            $wrapper.addClass('loading')
            const top = $(window).innerWidth() < 767 ? 90 : 130
            $([document.documentElement, document.body]).animate({
                scrollTop: $(".practices__filters-title").offset().top - top
            }, 850);
            setTimeout(function () {
                $wrapper.removeClass('loading')
            }, timing)
        }
    })();

});







